import { forwardRef } from 'react';
import Actions from './components/actions';
import Container from './components/container';
import FilePreviews from './components/file-previews';
import Inner from './components/inner';
import SearchBox from './components/search-box';
import { Props } from './types';

const SearchWidget = forwardRef<HTMLDivElement, Props>(({ children }, ref) => {
  return (
    <Container ref={ref}>
      <Inner>{children}</Inner>
    </Container>
  );
});

SearchWidget.displayName = 'SearchWidget';

export default Object.assign(SearchWidget, {
  Actions,
  SearchBox,
  FilePreviews,
});
